export default "/images/955e9296d0c85bbeda4b0798429a4162.avif";